import styled from 'styled-components';

export const NodeRow = styled.span`
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  width: 100%;
`;

export const NodeLabel = styled.span<{ $dimmed?: boolean }>`
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  opacity: ${({ $dimmed }) => ($dimmed ? 0.45 : 1)};
`;

/**
 * As ações só aparecem no hover, na linha selecionada ou com algo ativo (nó
 * isolado, oculto/parcial) — uma coluna de ícones em toda linha compete
 * visualmente com a hierarquia, que é o que a árvore existe pra mostrar.
 *
 * Sticky na borda direita: com a árvore rolada na horizontal, as ações não saem
 * da tela. O fundo repete o da linha para o rótulo não aparecer por baixo.
 *
 * Margem e padding vão em `&&`: o loader.css do viewer 3D zera os dois em
 * `.app-shell *` e, carregado depois, venceria — as ações paravam no fim do texto.
 */
export const NodeActions = styled.span<{ $visible: boolean }>`
  position: sticky;
  right: 0;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 2px;
  background: ${({ theme }) => theme.colors.surface.surface};
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transition: opacity 0.15s;

  .ant-tree-treenode:hover &,
  .ant-tree-treenode-selected &,
  &:focus-within {
    opacity: 1;
  }

  && {
    margin-left: auto;
    padding: 0 6px;
  }

  .ant-tree-treenode:hover & {
    background: ${({ theme }) => theme.colors.surface.surfaceContainer};
  }

  .ant-tree-treenode-selected &,
  .ant-tree-treenode-selected:hover & {
    background: ${({ theme }) => theme.colors.secondary.secondary};
  }
`;

export const NodeAction = styled.button`
  display: flex;
  align-items: center;
  border: none;
  background: none;
  cursor: pointer;

  && {
    padding: 2px;
  }

  &:focus-visible {
    outline: 1px solid ${({ theme }) => theme.colors.primary.primary};
    border-radius: 2px;
  }
`;

export const NodeCount = styled.span`
  flex-shrink: 0;
  font-size: 11px;
  color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
`;
